let $ = jQuery;

import ScrollMagic from 'scrollmagic';
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';

let AnimationManager = require('../utilities/animation-manager');

let idMenu = '#homepage-menu';

class HomepageMenu extends AnimationManager {

  constructor() {
    super();
  }

  createScenes() {
    // The innovation center scene is offset vertically.
    let $innovation = $("#innovation");
    let innovationOffset = Math.abs(parseInt($innovation.css("margin-top")));

    // The last two packages have top margins.
    let $expertise = $("#expertise");
    let expertiseOffset = parseInt($expertise.find('.package').css('margin-top'));
    let $expertiseImage = $expertise.find('.header img');
    let $features = $("#features");
    let featuresOffset = parseInt($features.find('.package').css('margin-top'));

    let duration = 0;

    // Header/Hero
    duration = $('#intro').outerHeight(true);
    new ScrollMagic.Scene({
        triggerElement: '#intro',
        duration: duration,
      })
        .setClassToggle('#homepage-menu', 'homepage-menu__active-intro') // add class toggle
        // .addIndicators() // add indicators (requires plugin)
        .addTo(this.controller);

    // Care
    duration = $('#care').outerHeight(true);
    new ScrollMagic.Scene({
        triggerElement: '#care',
        duration: duration,
        offset: 0,
      })
        .setClassToggle('#homepage-menu', 'homepage-menu__active-care') // add class toggle
        // .addIndicators() // add indicators (requires plugin)
        .addTo(this.controller);

    // Science
    duration = $('#science').outerHeight(true);
    new ScrollMagic.Scene({
        triggerElement: '#science',
        duration: duration + innovationOffset,
        offset: 0,
      })
        .setClassToggle('#homepage-menu', 'homepage-menu__active-science') // add class toggle
        // .addIndicators() // add indicators (requires plugin)
        .addTo(this.controller);

    // Innovation
    duration = $('#innovation').outerHeight(true);
    new ScrollMagic.Scene({
        triggerElement: '#innovation',
        duration: duration - innovationOffset,
        offset: innovationOffset * 2,
      })
        .setClassToggle('#homepage-menu', 'homepage-menu__active-innovation') // add class toggle
        // .addIndicators() // add indicators (requires plugin)
        .addTo(this.controller)

    // Expertise
    duration = $expertise.outerHeight(true);
    new ScrollMagic.Scene({
        triggerElement: '#expertise',
        duration: duration + expertiseOffset,
        offset: -expertiseOffset,
      })
        .setClassToggle('#homepage-menu', 'homepage-menu__active-expertise') // add class toggle
        // .addIndicators() // add indicators (requires plugin)
        .addTo(this.controller);

    // Expertise Header Image. -- If not there skip, so we don't change text color.
    if ($expertiseImage.length > 0) {

      duration = $expertiseImage.outerHeight();
      new ScrollMagic.Scene({
          triggerElement: '#expertise .header img',
          duration: duration,
          offset: 0,
        })
          .setClassToggle('#homepage-menu', 'homepage-menu__active-expertise-image') // add class toggle
          // .addIndicators() // add indicators (requires plugin)
          .addTo(this.controller);
    }

    // Features
    duration = $features.outerHeight(true);
    new ScrollMagic.Scene({
        triggerElement: '#features',
        duration: duration + featuresOffset,
        offset: -featuresOffset,
      })
        .setClassToggle('#homepage-menu', 'homepage-menu__active-features') // add class toggle
        // .addIndicators() // add indicators (requires plugin)
        .addTo(this.controller);

  }

  destroyScenes() {
    super.destroyScenes();
  }

}

function init() {
  if($(idMenu).length) {
    let homepageMenu = new HomepageMenu();
  }
}

if(typeof Drupal === 'undefined') {

  // Initialize for Styleguide
  $(document).ready(() => {
    init();
  });

} else {

  // Export for Drupal
  module.exports = {
    attach: function (context, settings) {
      init();
    }
  };

}
